import { loadStripe } from '@stripe/stripe-js';
import { getRuntimeConfigValue } from './runtimeConfig';

export const STRIPE_PUBLISHABLE_KEY = getRuntimeConfigValue('stripePublishableKey')
  || process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY?.trim()
  || '';

/** Stripe.js is loaded directly from Stripe; the publishable key is safe to expose to the browser. */
export const stripePromise = STRIPE_PUBLISHABLE_KEY
  ? loadStripe(STRIPE_PUBLISHABLE_KEY)
  : null;

export const isStripeConfigured = Boolean(STRIPE_PUBLISHABLE_KEY);
